let language = {
    FOOTER_QPSON_TITLE: "关于",
    FOOTER_QPSON_JUMP_TITLE_1: "连接您的商店",
    FOOTER_QPSON_JUMP_TITLE_2: "按需打印",
    FOOTER_QPSON_JUMP_TITLE_3: "无需库存即可网上销售",
    FOOTER_QPSON_JUMP_TITLE_4: "成为一个合伙人",
    FOOTER_QPSON_JUMP_TITLE_Sell: "网上销售",
    FOOTER_QPSON_JUMP_TITLE_CATALOG: "产品目录",
    FOOTER_QPSON_JUMP_TITLE_SHOPIFY: "在 Shopify 上销售",
    FOOTER_QPSON_JUMP_TITLE_WOOCOMMERCE: "在 WooCommerce 上销售",
    FOOTER_QPSON_JUMP_TITLE_API: "API",
    FOOTER_QPSON_JUMP_TITLE_SUPPORT: "支持",
};

export { language }